const pageNameKey = "otaFirmwareBackupDrawerModal";

export const otaFirmwareBackupDrawerModalEn = {
  [pageNameKey]: {
    createFirmwareBackupText: "Create Firmware Backup",
    backupDetailsText: "Backup Details",
    createBackupText: "Create Backup",
    cancelText: "Cancel",
    fixValidateFieldText: "Please fix following fields: ",
    firmwareVersionText: "Firmware Version",
    backupNameText: "Backup Name",
    backupNotesText: "Backup Notes",
    namePlaceholderText: "Choose precise name",
    notesPlaceholderText:
      "What is unique for this backup and valuable to know by others in the future?",
    successMsg: "Firmware backup created successfully",
    errorMsg: "Something went wrong while creating backup.",
    failedToCreateBackup: "Failed to create backup",
  },
};

export const otaFirmwareBackupDrawerModalPtBr = {
  [pageNameKey]: {
    createFirmwareBackupText: "Criar backup do firmware",
    backupDetailsText: "Detalhes do backup",
    createBackupText: "Criar backup",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrija os seguintes campos: ",
    firmwareVersionText: "Versão do firmware",
    backupNameText: "Nome do backup",
    backupNotesText: "Notas de backup",
    namePlaceholderText: "Escolha um nome preciso",
    notesPlaceholderText:
      "O que há de particular neste backup que seria importante para outras pessoas saberem no futuro?",
    successMsg: "Backup do firmware criado com sucesso",
    errorMsg: "Algo deu errado na criação do backup.",
    failedToCreateBackup: "Falha ao criar backup",
  },
};

export const otaFirmwareBackupDrawerModalDe = {
  [pageNameKey]: {
    createFirmwareBackupText: "Erstellen Sie ein Firmware-Backup",
    backupDetailsText: "Sicherungsdetails",
    createBackupText: "Backup erstellen",
    cancelText: "Stornieren",
    fixValidateFieldText: "Bitte korrigieren Sie die folgenden Felder:",
    firmwareVersionText: "Firmware-Version",
    backupNameText: "Sicherungsname",
    backupNotesText: "Sicherungsnotizen",
    namePlaceholderText: "Wählen Sie einen genauen Namen",
    notesPlaceholderText:
      "Was ist das Besondere an diesem Backup und was ist für andere in Zukunft wertvoll zu wissen?",
    successMsg: "Firmware-Backup erfolgreich erstellt",
    errorMsg: "Beim Erstellen des Backups ist ein Fehler aufgetreten.",
    failedToCreateBackup: "Backup konnte nicht erstellt werden",
  },
};

export const otaFirmwareBackupDrawerModalZhHans = {
  [pageNameKey]: {
    createFirmwareBackupText: "创建固件备份",
    backupDetailsText: "备份详情",
    createBackupText: "创建备份",
    cancelText: "取消",
    fixValidateFieldText: "请修改以下字段：",
    firmwareVersionText: "固件版本",
    backupNameText: "备份名称",
    backupNotesText: "备份笔记",
    namePlaceholderText: "选择准确的名称",
    notesPlaceholderText:
      "此备份有哪些独特之处，对未来其他人来说有哪些值得了解的地方？",
    successMsg: "固件备份创建成功",
    errorMsg: "创建备份时发生错误。",
    failedToCreateBackup: "创建备份失败",
  },
};

export const otaFirmwareBackupDrawerModalIt = {
  [pageNameKey]: {
    createFirmwareBackupText: "Crea backup firmware",
    backupDetailsText: "Dettagli di backup",
    createBackupText: "Crea backup",
    cancelText: "Annulla",
    fixValidateFieldText: "Correggi i seguenti campi: ",
    firmwareVersionText: "Versione del firmware",
    backupNameText: "Nome del backup",
    backupNotesText: "Note di backup",
    namePlaceholderText: "Scegli un nome",
    notesPlaceholderText:
      "Cosa è unico in questo backup e utile per gli altri utenti?",
    successMsg: "Backup firmware creato con successo",
    errorMsg: "Si è verificato un errore durante la creazione del backup.",
    failedToCreateBackup: "Impossibile creare il backup",
  },
};

export const otaFirmwareBackupDrawerModalEs = {
  [pageNameKey]: {
    createFirmwareBackupText: "Crear copia de seguridad del firmware",
    backupDetailsText: "Detalles de la copia de seguridad",
    createBackupText: "Crear copia de seguridad",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrige los siguientes campos: ",
    firmwareVersionText: "Versión del firmware",
    backupNameText: "Nombre de la copia de seguridad",
    backupNotesText: "Notas de respaldo",
    namePlaceholderText: "Elige un nombre preciso",
    notesPlaceholderText:
      "¿Qué es único de esta copia de seguridad y valioso que otros sepan en el futuro?",
    successMsg: "Copia de seguridad del firmware creada correctamente",
    errorMsg: "Se produjo un error al crear la copia de seguridad.",
    failedToCreateBackup: "No se pudo crear la copia de seguridad",
  },
};

export const otaFirmwareBackupDrawerModalNl = {
  [pageNameKey]: {
    backupDetailsText: "Back-updetails",
    backupNameText: "Back-upnaam",
    backupNotesText: "Back-upnotities",
    cancelText: "Annuleren",
    createBackupText: "Back-up maken",
    createFirmwareBackupText: "Maak een firmwareback-up",
    errorMsg: "Er is een fout opgetreden bij het maken van de back-up.",
    failedToCreateBackup: "Aanmaken van back-up mislukt",
    firmwareVersionText: "Firmwareversie",
    fixValidateFieldText: "Corrigeer de volgende velden: ",
    namePlaceholderText: "Kies een duidelijke naam",
    notesPlaceholderText:
      "Wat is bijzonder aan deze back-up en wat is nuttig voor anderen om in de toekomst te weten?",
    successMsg: "Firmwareback-up succesvol aangemaakt",
  },
};

export const otaFirmwareBackupDrawerModalTr = {
  [pageNameKey]: {
    backupDetailsText: "Yedekleme Ayrıntıları",
    backupNameText: "Yedekleme Adı",
    backupNotesText: "Yedekleme Notları",
    cancelText: "İptal etmek",
    createBackupText: "Yedekleme Oluştur",
    createFirmwareBackupText: "Firmware Yedeği Oluşturun",
    errorMsg: "Yedekleme oluşturulurken bir şeyler ters gitti.",
    failedToCreateBackup: "Yedekleme oluşturulamadı",
    firmwareVersionText: "Donanım Yazılımı Sürümü",
    fixValidateFieldText: "Lütfen aşağıdaki alanları düzeltin:",
    namePlaceholderText: "Tam adı seçin",
    notesPlaceholderText:
      "Bu yedekleme için benzersiz olan ve gelecekte başkaları tarafından bilinmesi değerli olan şey nedir?",
    successMsg: "Ürün yazılımı yedeklemesi başarıyla oluşturuldu",
  },
};
